import React, { useEffect, useState } from "react";
import {
  DeactivateAccountContextImport,
  DeactivateAccountContextProvider,
} from "../../../../provider/deactivate_account/DeactivateAccountContextProvider";
import Div from "../../../../widget/common/ui/Div";
import { ButtonDouble } from "../../../../widget/common/form/Button";
import Input from "../../../../widget/common/form/Input";
import Center from "../../../../widget/common/ui/Center";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { textCase } from "../../../../service/ui/UI";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ProfileDetails } from "../../../../model/settings/SettingsPersonalInfoModel";
import Loader from "../../../../widget/common/ui/Loader";
import {
  SettingsPersonalProfileContextImport,
  SettingsPersonalProfileContextProvider,
} from "../../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";

const DeactivateAccountAskPasswordAlert = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SettingsPersonalProfileContextProvider>
      <DeactivateAccountContextProvider>
        <DeactivateAccountAskPassworBody type={type} />
      </DeactivateAccountContextProvider>
    </SettingsPersonalProfileContextProvider>
  );
};

const DeactivateAccountAskPassworBody = (props: {
  type?: number | undefined;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const {
    handleOnChange,
    passwordField,
    closeDeleteConfirmation,
    submitDeleteAPI,
  } = DeactivateAccountContextImport();
  const { getProfileInfo, profileDetail } =
    SettingsPersonalProfileContextImport();

  const [showText, setShowText] = useState<boolean>(false);
  const [profileInfo, setProfileInfo] = useState<ProfileDetails | null>(null);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };

  useEffect(() => {
    getProfileInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setProfileInfo(profileDetail);
  }, [profileDetail]);

  return (
    <>
      {profileDetail == null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <form autoComplete="off">
          <Div className="pb-5">
            <Center>
              <LogoRound
                url={profileInfo?.logo_details?.file_url!}
                isProfile={true}
                name={`${profileInfo?.first_name!} ${profileInfo?.last_name!}`}
                size={type === 2 ? 100 : 80}
              />
            </Center>
            <SpacingHeight value={18} />
            <TextBlock
              textColor="theme-label"
              fontSize="20_21"
              fontName="bold"
              center={true}
            >
              {textCase(
                `${profileInfo?.first_name!} ${profileInfo?.last_name}`
              )}
            </TextBlock>
          </Div>

          <Input
            type={`${showText ? "text" : "password"}`}
            name="password"
            handleOnChange={handleOnChange}
            value={passwordField}
            placeHolder="password"
            suffixType="icon"
            suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
            suffixHandleClick={suffixHandleClick}
            validate={true}
          />
          <ButtonDouble
            title1="cancel"
            title2="submit"
            handleClick1={() => closeDeleteConfirmation()}
            handleClick2={() => submitDeleteAPI()}
          />
        </form>
      )}
    </>
  );
};

export default DeactivateAccountAskPasswordAlert;
